import React from 'react';
import { useLocation } from 'react-router-dom';
import { isBlogger } from '../../../utils/accessService';
import { cropPublicId } from '../../../utils/cropPublicId';
import { useBackButton } from '../../../utils/useBackButton';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { useProfileSticker } from '../../hooks/useProfileSticker';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Avatar } from '../../media/Avatar';
import { Sticker } from '../../styles';
import { Typography } from '../../typography/Typography';
import { UserUI } from '../types';
import { Chevron, ItemContainer } from './styles';

const ICON_SIZE = 24;

export function OtherMenuOptionsDialog() {
    const t = useTranslation();
    const onNavigateBack = useBackButton();

    const { user } = useLocation().state as { user: UserUI };
    const { isVisible: isProfileStickerVisible } = useProfileSticker(user);

    return (
        <SmartDrawer
            onClose={onNavigateBack}
            mainContent={
                <Box p={1} pt={2} width="100%">
                    {!isBlogger(user?.role) && (
                        <ItemContainer to="/profile">
                            <Flex my={0.5} direction="row" alignItems="center">
                                <Flex width={ICON_SIZE} height={ICON_SIZE} position="relative">
                                    <Avatar
                                        src={user.avatarUrl}
                                        title={user.displayName}
                                        size={ICON_SIZE}
                                    />
                                    {isProfileStickerVisible ? <Sticker /> : null}
                                </Flex>
                                <Typography color="var(--color-primary)" variant="body" ml={1}>
                                    {t('Профиль')}
                                </Typography>
                            </Flex>
                            <Chevron />
                        </ItemContainer>
                    )}

                    <ItemContainer to={`/businesses/${user.profile?.publicId}`}>
                        <Flex my={0.5} direction="row" alignItems="center">
                            <Avatar
                                src={user.profile?.avatarUrl}
                                title={user.profile?.displayName}
                                size={ICON_SIZE}
                            />
                            <Box>
                                <Typography color="var(--color-primary)" variant="body" ml={1}>
                                    {t(cropPublicId(user.profile?.publicId || ''))}
                                </Typography>
                                <Typography color="var(--color-secondary)" variant="caption" ml={1}>
                                    {user.profile?.isService
                                        ? t('бизнес-услуги')
                                        : t('бизнес-профиль')}
                                </Typography>
                            </Box>
                        </Flex>
                        <Chevron />
                    </ItemContainer>
                </Box>
            }
        />
    );
}
